import additionMotivesReducer from './reducers';

export { default as additionMotivesTypes } from './types';
export { default as additionMotivesActions } from './actions';
export { default as additionMotivesSagas } from './sagas';

export default additionMotivesReducer;
